import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../components/card/card";
import ImageViewer from "../../../components/ImageViewer";
import { printDate, printLocation } from "../../../utils/helper";
import React, { useState, useEffect } from "react";
import { companyProfile } from "../../../api";
import { parserAPI } from "../../../utils/parser";
import ProblemTypeTab from "./ProblemTypeTab";
import { useAuth } from "../../../contexts/AuthContext";
import ConfirmationDlg from "../../../components/ConfirmationDlg";
import NormalInput from "../../../components/form/HorizontalNormalInput";
import { toast } from "react-toastify";

function ServiceGroupConfiguration() {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openLocationLevelSetting, setOpenLocationLevelSetting] =
    useState(false);
  const { config, setConfig } = useAuth();
  const [problemTypeWording, setProblemTypeWording] = useState([]);
  const [problemTypeWordingData, setProblemTypeWordingData] = useState([]);
  const [grouped, setGrouped] = useState([]);

  useEffect(() => {
    if (config) {
      setProblemTypeWording(config.problem_type_wording.split(","));
      setProblemTypeWordingData(config.problem_type_wording.split(","));
    }
  }, [config]);

  const handleChangeLocationWording = (value, index) => {
    console.log(value, index);
    setProblemTypeWordingData((prev) => {
      const newData = [...prev];
      newData[index] = value;
      return newData;
    });
  };

  const isDuplicateLocationWording = (value, currentIndex) => {
    if (!value || value.trim() === "") return false;

    return problemTypeWordingData.some(
      (item, index) =>
        index !== currentIndex &&
        item.toLowerCase().trim() === value.toLowerCase().trim()
    );
  };
  const addMoreLocationWording = () => {
    setProblemTypeWordingData((prev) => {
      const newData = [...prev];
      newData.push("");
      return newData;
    });
  };
  const deleteLocationWording = (index) => {
    if (grouped[index]) {
      toast.error("Unable to delete, there are locations in this level");
      return;
    }
    setProblemTypeWordingData((prev) => {
      const newData = [...prev];
      newData.splice(index, 1);
      return newData;
    });
  };

  const SubmitLocationWording = async () => {
    if (problemTypeWordingData.some((item) => item === "")) {
      toast.error("Please fill all the fields");
      return;
    }

    // Check for duplicate location wording entries
      const duplicates = problemTypeWordingData.filter(
      (item, index) => problemTypeWordingData.indexOf(item) !== index
    );

    if (duplicates.length > 0) {
      toast.error(
        `Duplicate location names found: ("${duplicates[0]}"). Please ensure all location levels have unique names.`
      );
      return;
    }

    // Check for case-insensitive duplicates
    const lowerCaseItems = problemTypeWordingData.map((item) =>
      item.toLowerCase()
    );
    const caseInsensitiveDuplicates = lowerCaseItems.filter(
      (item, index) => lowerCaseItems.indexOf(item) !== index
    );

    if (caseInsensitiveDuplicates.length > 0) {
      const originalDuplicate = problemTypeWordingData.find(
        (item) => item.toLowerCase() === caseInsensitiveDuplicates[0]
      );
      toast.error(
        `Duplicate location names found (case-insensitive): "${originalDuplicate}". Please ensure all location levels have unique names.`
      );
      return;
    }

    try {
      setLoading(true);
      const res = await companyProfile.update(config.id, {
        problem_type_wording: problemTypeWordingData.join(","),
      });
      if (res.ok) {
        const body = await res.json();
        if (body.success) {
          toast.success("Successfully Saved");
          setConfig({
            ...config,
            problem_type_wording: problemTypeWordingData.join(","),
          });
          setOpenLocationLevelSetting(false);
          setSelectedIndex(0);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const onGrouped = (grouped) => {
    setGrouped(grouped);
  };

  const hasAnyDuplicates = () => {
    return problemTypeWordingData.some((item, index) =>
      isDuplicateLocationWording(item, index)
    );
  };

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Setup</a>
            </li>
            <li className="breadcrumb-item active">Service Group</li>
          </ol>
        </div>
      </div>

      <div className="row gx-4">
        <div className="col-lg-12">
          <Card className="mb-4">
            <CardHeader>
              <div className="d-flex align-items-center">
                <h5 className="flex-1">Service Group</h5>
                {/* <button
                  className="btn btn-outline-theme ml-auto"
                  onClick={() => setOpenLocationLevelSetting(true)}
                >
                  Update Location Level
                </button> */}
              </div>

              <ConfirmationDlg
                title="Update Location Level"
                open={openLocationLevelSetting}
                onClose={() => setOpenLocationLevelSetting(false)}
                onSubmit={() => SubmitLocationWording()}
                btnSubmitText="Update"
                btnCancelText="Cancel"
                loading={loading}
                disableSubmit={
                  hasAnyDuplicates() ||
                  problemTypeWordingData.some((item) => item.trim() === "")
                }
              >
                {problemTypeWordingData.map((item, index) => {
                  const isDuplicate = isDuplicateLocationWording(item, index);
                  return (
                    <div key={index}>
                      <div className="d-flex align-items-center">
                        <div className="col-md-10 me-2">
                          <NormalInput
                            full={true}
                            label={"level " + (index + 1)}
                            value={problemTypeWordingData[index]}
                            onchange={(e) =>
                              handleChangeLocationWording(e.target.value, index)
                            }
                            className={isDuplicate ? "is-invalid" : ""}
                          />
                        </div>
                        {index > 1 && (
                          <button
                            className="btn btn-outline-danger col-md-1 mt-2"
                            onClick={() => deleteLocationWording(index)}
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}

                <button
                  className="btn btn-primary"
                  onClick={addMoreLocationWording}
                >
                  Add More
                </button>
              </ConfirmationDlg>
            </CardHeader>
            <CardBody>
              <ul className="nav nav-tabs pt-3 ps-4 pe-4">
                {problemTypeWording.map((item, index) => {
                  return (
                    <li className="nav-item me-1" key={index}>
                      <a
                        href={"#tab" + index}
                        className={
                          index == selectedIndex
                            ? "nav-link active"
                            : "nav-link"
                        }
                        data-bs-toggle="tab"
                        onClick={() => setSelectedIndex(index)}
                      >
                        {item}
                      </a>
                    </li>
                  );
                })}
              </ul>
              <div className="tab-content pt-3">
                <div className={"tab-pane fade show active"}>
                  <ProblemTypeTab
                    selectedIndex={selectedIndex}
                    onGrouped={onGrouped}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
export default ServiceGroupConfiguration;
